import { createApp } from 'vue';
import JobAdvertisementList from '../components/JobAdvertisementList.vue';

document.querySelectorAll('[data-job-advertisement-app]').forEach(el => {
    const config = JSON.parse(el.dataset.jobAdvertisementApp);
    createApp(JobAdvertisementList, config).mount(el);
});
